import store from '@/store';
import Vue from 'vue';
import config from 'BRAND/config';

const authorityGuard = (to, from, next) => {
  // Dirty solution to ensure that has account
  // information before check the authorities
  store.dispatch('retrieveUserAccount', {context: new Vue()}).then(() => {
    to.meta.feature === undefined || hasAuthorities(to.meta.feature)
      ? next()
      : next(config.defaultFallback);
  }, () => {
    next();
  });
};

const hasAuthorities = (featureName) => {
  const feature = config.featurePermission.find(obj => {
    return obj.feature === featureName;
  });
  const userAccount = store.getters.getUserAccount;
  if (feature && userAccount && userAccount.authorities) {
    for (let userAuth of userAccount.authorities) {
      if (feature.authorities.includes(userAuth)) {
        return true;
      }
    }
  }
  return false;
};

export default {
  authorityGuard
};



// WEBPACK FOOTER //
// ./src/router/AuthorityGuard.js